module.exports = __webpack_public_path__ + "img/digital-wallet-250.f1f86e70.png";